import { tableStyles } from 'css/tableStyles';
import React, {  useMemo } from 'react';
import DataTable from 'components/DataTable';
import styles from './index.module.scss';
import CustomLink from 'components/TableLink';
import DeleteActionForTable from 'components/DeleteActionForTableData';
import { removeItemFromCart } from 'services';
import { showError } from 'utils';

const conditionalRowStyles = [
  {
    when: row => row.stock < row.count || !row.available || !row.active,
    style: {
      border: '2px solid #ff9494 !important',
      '&:hover': {
        cursor: 'pointer',
      },
    },
  },
];


const ListItems = props => {
  const { items = [], userId, getCart } = props;
  
  const removeItemFromCartFn = async(itemId) => {
    try {
      await removeItemFromCart({
        inventoryItemId: itemId, quantity: 0, userId,
      });
      getCart();
    } catch(e) {
      showError(e);
    }
  };

  const columns = useMemo(() =>  [
    {
      name: 'ItemID',
      selector: 'objectId',
      sortable: false,
      // eslint-disable-next-line react/display-name
      cell: row => row ? (
        <CustomLink
          text={row?.objectId}
          linkTo={`/inventory-items/${row?.objectId}`}
        />
      ): '-',
    },
    {
      name: 'Name',
      selector: 'name',
      sortable: true,
      format: row => row?.name || '-',
    },
    {
      name: 'Stock',
      selector: 'stock',
      sortable: true,
    },
    {
      name: 'Quantity',
      selector: 'count',
      sortable: true,
    },
    { 
      name: 'Available',
      selector: 'available',
      sortable: true,
      cell: (row)=> row?.available ? 'True' : 'False',
    },
    {
      name: 'Price',
      selector: 'price',
      sortable: true,
    },
    {
      name: 'Action',
      selector: '',
      sortable: true,
      // eslint-disable-next-line react/display-name
      cell: (row: Record<string, any>) => (
        <div className={'ml-3'}>
          <DeleteActionForTable
            onClick={() => removeItemFromCartFn(row.objectId)}
          />
        </div>
      ),
    },
  ], []);
  
  return (
    <div className={styles['cart-items-container']}>
      <div className={styles['section-header']}>
        <div className={styles['section-heading']}>Cart Items</div>
      </div>
      <DataTable
        columns={columns}
        noHeader={true}
        data={items}
        highlightOnHover={true}
        customStyles={tableStyles}
        keyField="objectId"
        conditionalRowStyles={conditionalRowStyles}
      />
    </div>
  );
};

export default ListItems;